import classnames from 'classnames';
import React from 'react';
import { HeadingLevels } from '../../../../enums/headings.js';

const BaseHeading = (props)=>{
    const { children, className, level = HeadingLevels.h1, ...otherProps } = props;
    const Tag = level;
    return /*#__PURE__*/ React.createElement(Tag, {
        ...otherProps,
        className: classnames({
            'bf-heading': true,
            [`${className}`]: className
        })
    }, children);
};

export { BaseHeading };
//# sourceMappingURL=base-heading.js.map
